import React from "react"
import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts"

const data = [
  { name: "Jan", sent: 3200, received: 875 },
  { name: "Feb", sent: 5550, received: 2000 },
  { name: "March", sent: 5000, received: 3200 },
  { name: "April", sent: 6000, received: 2500 },
  { name: "May", sent: 6500, received: 1500 },
  { name: "June", sent: 5350, received: 1750 },
]

const SentVsReceived = () => {
  return (
    <div className="w-full h-80"> 
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart
          data={data}
          margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
        >
          <defs>
            <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#1970E6" stopOpacity={0.8} />
              <stop offset="95%" stopColor="#1970E6" stopOpacity={0} />
            </linearGradient>
            <linearGradient id="colorPv" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#E41B1B" stopOpacity={0.8} />
              <stop offset="95%" stopColor="#E41B1B" stopOpacity={0} />
            </linearGradient>
          </defs>
          <XAxis dataKey="name" />
          <YAxis ticks={[0, 1750, 3500, 5250, 7000]}/>
          <CartesianGrid strokeDasharray="3 3" />
          <Tooltip />
          <Area
            type="monotone"
            dataKey="sent"
            stroke="#1970E6"
            fillOpacity={1}
            fill="url(#colorUv)"
            name="Sent"
          />
          <Area
            type="monotone"
            dataKey="received"
            stroke="#E41B1B"
            fillOpacity={1}
            fill="url(#colorPv)"
            name="Received"
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  )
}

export default SentVsReceived
